<template>
	<div class="result-splash">
		<p class="result-splash__cta">
			{{ $t('result.cta') }}
		</p>
		<v-button class="result-splash__button" light v-touch:tap="seeResults">
			{{ $t('result.button') }}
		</v-button>
	</div>
</template>

<style lang="sass">
.result-splash
  background:
    image: url('/img/illustrations/result.jpg')
    size: cover
    position: center center
  width: 100%
  height: 100vh
  height: calc(var(--vh, 1vh) * 100)
  overflow: auto
  display: flex
  flex-direction: column

  &__cta
    margin: auto auto 5% auto
    color: var(--white)
    font:
      family: var(--font-family-title)
      size: var(--font-size-large)
    text:
      align: center
      transform: uppercase
      decoration: none

  &__button
    margin: 5% auto auto auto
    max-width: 500px

  @media screen and (max-width: 64em)
    &__cta
      font-size: var(--font-size-mobile-cover)
</style>

<script>
import VButton from '@/components/VButton'

export default {
	name: 'ResultSplash',

	components: {
		VButton
	},

	methods: {
		seeResults() {
			this.$ga.send('skin_concierge', {
				skin_concierge_action: 'view result'
			})
			this.$router.push('mail-form')
		}
	}
}
</script>
